<template>
  <div class="xywcqk_content">
    <NOdata v-if="tableData.length == 0 && isLoad" title="暂无数据~"></NOdata>
    <div v-else class="qz-list">
      <div
        class="qz-list-item"
        v-for="(item, index) in tableData"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="qz-list-item-content">
          <img class="qz-list-item-icon" src="@/assets/images/jsb.png" alt="" />
          <div class="qz-list-item-text">
            <h4 class="qz-list-item-title">{{ item.xfyqmc }}</h4>
            <p class="qz-list-item-label">要求学分：{{ item.xfyq }}</p>
          </div>
          <p class="qz-list-item-link">详情<van-icon name="arrow" /></p>
        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      :style="{ height: '100%', width: '100%' }"
      closeable
    >
      <h3 style="margin: 15px 0 0 16px; color: #505d9c">学分要求详情</h3>
      <NOdata v-if="popInfo.length == 0" title="暂无数据~"></NOdata>
      <div v-else class="xfyq-info">
        <div
          class="executePlan_list"
          v-for="(item, index) in popInfo"
          :key="index"
        >
          <template v-if="item.xfyqid == 'cxcyxfyq'"> 
            <h4>{{ item.xmmc }}</h4>
            <p>项目编号: {{ item.xmbh }}</p>
            <p>学期: {{ item.sj }}</p>
            <p>学分: {{ item.xf }}</p>
          </template>
          <template v-else>
            <h4>{{ item.kcmc }}</h4>
            <p>课程编号: {{ item.kch }}</p>
            <p>课程性质: {{ item.kcxz }}</p>
            <div>
              <div>
                <p>学分： {{ item.xf }}</p>
              </div>
              <div>
                <p>学时： {{ item.zxs }}</p>
              </div>
            </div>
            <p>是否计划内： {{ item.sfjhkc == "1" ? "是" : "否" }}</p>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      tableData: [],
      isLoad: false,
      show: false,
      popInfo: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.zxxywcqk();
      this.tableData.push(...res.data.txxfyqlist);
      this.tableData.push(res.data.cxcyxfyq);
      res.data.bxhjxfyq ? this.tableData.push(res.data.bxhjxfyq) : "";
      // this.tableData.push({
      //   xfyqmc: "总计",
      //   xfyq: res.data.zxfyq,
      //   hdxf: res.data.zhdxf,
      //   hxxf: res.data.zhxxf,
      //   bljl: "",
      // });
      this.isLoad = true;
    },
    goDetail(item) {
      console.log(item, "item");
      if(item.jhxf != 0 ){
       this.show = true;
      }
      this.popInfo = item.kclist || [];
    },
  },
};
</script>

<style lang="less" scoped>
.xywcqk_content {
  // padding: 10px 0;
  .qz-list {
    padding: 0 15px 10px;
    background-color: #f2f2f4;

    .qz-list-item {
      border-radius: 6px;
      margin-top: 10px;
      background-color: #fff;
      padding: 16px 15px;
      line-height: 20px;

      .qz-list-item-content {
        display: flex;
        align-items: center;
        position: relative;

        .qz-list-item-icon {
          width: 40px;
          height: 40px;
        }

        .qz-list-item-text {
          margin-left: 9px;

          .qz-list-item-title {
            font-size: 16px;
            color: #333333;
            line-height: 22px;
          }

          .qz-list-item-label {
            font-size: 14px;
            color: #999999;
            font-weight: Medium;
            margin-top: 6px;
            line-height: 20px;
          }
        }

        .qz-list-item-link {
          color: @attendance-background-color-1;
          font-size: 14px;
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .van-popup {
    background-color: #f2f2f4;
  }
  .xfyq-info {
    box-sizing: border-box;
    padding: 0px 15px 0;
    height: 95%;
    overflow-y: scroll;
    .executePlan_list {
      width: 100%;
      box-sizing: border-box;
      padding: 20px;
      background: #fff;
      display: flex;
      flex-direction: column;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      &:first-of-type {
        margin-top: 10px;
      }
      > div {
        display: flex;
        justify-content: space-between;
        width: 100%;
        > div {
          width: 45%;
        }
      }
      h4 {
        text-align: left;
        margin-bottom: 4px;
        color: @attendance-color-8;
        font-size: 16px;
        line-height: 22px;
      }
      p {
        color: @attendance-color-2;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/Cultivate/xfyq.vue